import { RouteRecordRaw } from 'vue-router';

import ChatAudienceView from '@/views/chat/ChatAudienceView.vue';
import ChatConferenceView from '@/views/chat/ChatConferenceView.vue';
import ChatEndedView from '@/views/chat/ChatEndedView.vue';
import ChatEntranceView from '@/views/chat/ChatEntranceView.vue';
import ChatGeneralView from '@/views/chat/ChatGeneralView.vue';
import ChatIntroView from '@/views/chat/ChatIntroView.vue';
import ChatMaxExceededView from '@/views/chat/ChatMaxExceededView.vue';
import ChatMeetingView from '@/views/chat/ChatMeetingView.vue';
import ChatScreenMultiView from '@/views/chat/ChatScreenMultiView.vue';
import ChatScreenView from '@/views/chat/ChatScreenView.vue';
import ChatScriptDownloadView from '@/views/chat/ChatScriptDownloadView.vue';
import ChatSingleView from '@/views/chat/ChatSingleView.vue';
import ChatSubtitleView from '@/views/chat/ChatSubtitleView.vue';
import ChatZoomEntranceView from '@/views/chat/ChatZoomEntranceView.vue';
import ChatZoomRegisterView from '@/views/chat/ChatZoomRegisterView.vue';
import ChatLayout from '@/views/layout/ChatLayout.vue';

export default function chatRoutes(): RouteRecordRaw[] {
  return [
    // 입장방
    {
      path: '/chat/entrance/:code',
      name: 'chat-entrance',
      component: ChatEntranceView,
      props: true,
    },
    {
      path: '/chat',
      component: ChatLayout,
      meta: { domain: 'CHAT' },
      children: [
        // 대화
        {
          path: '/chat/general/:code',
          name: 'chat-general',
          component: ChatGeneralView,
          meta: { chatType: 'GENERAL', theme: 'light' },
          props: true,
        },
        // 컨퍼런스
        {
          path: '/chat/conference/:code',
          name: 'chat-conference',
          component: ChatConferenceView,
          meta: { chatType: 'CONFERENCE', theme: 'light' },
          props: true,
        },
        // 청취
        {
          path: '/chat/audience',
          name: 'chat-audience',
          component: ChatAudienceView,
          meta: { chatType: 'AUDIENCE', theme: 'dark' },
        },
        // 청취 + 파트너코드
        {
          path: '/chat/audience/:partnerCode',
          name: 'chat-audience-code',
          component: ChatAudienceView,
          meta: { chatType: 'AUDIENCE', theme: 'dark' },
        },
        // 미팅
        {
          path: '/chat/meeting/:code',
          name: 'chat-meeting',
          component: ChatMeetingView,
          meta: { chatType: 'MEETING', theme: 'dark' },
          props: true,
        },
      ],
    },
    // 싱글
    {
      path: '/chat/single',
      name: 'chat-single-query',
      component: ChatSingleView,
      meta: { chatType: 'SINGLE', domain: 'CHAT', theme: 'light' },
    },
    // 싱글 + 파트너코드
    {
      path: '/chat/single/:partnerCode?',
      name: 'chat-single',
      component: ChatSingleView,
      meta: { chatType: 'SINGLE', domain: 'CHAT', theme: 'light' },
    },
    // 자막모드
    {
      path: '/chat/subtitle',
      name: 'chat-subtitle',
      component: ChatSubtitleView,
      meta: { chatType: 'SUBTITLE' },
    },
    // 스크린모드
    {
      path: '/chat/screen',
      name: 'chat-screen',
      component: ChatScreenView,
      meta: { chatType: 'SCREEN' },
    },
    // 스크린모드 듀얼 노출
    {
      path: '/chat/screen-dual',
      name: 'chat-screen-dual',
      component: ChatScreenMultiView,
    },
    // ZOOM
    {
      path: '/chat/zoom',
      name: 'chat-zoom',
      children: [
        {
          path: 'intro',
          name: 'chat-zoom-intro',
          component: ChatIntroView,
        },
        {
          path: 'register',
          name: 'chat-zoom-register',
          component: ChatZoomRegisterView,
        },
        {
          path: 'entrance',
          name: 'chat-zoom-entrance',
          component: ChatZoomEntranceView,
        },
      ],
    },
    // 기록다운로드
    {
      path: '/chat/script/download/:chatId',
      name: 'chat-script-download',
      component: ChatScriptDownloadView,
    },
    {
      path: '/chat/ended',
      name: 'chat-ended',
      component: ChatEndedView,
    },
    {
      path: '/chat/max-exceeded',
      name: 'chat-max-exceeded',
      component: ChatMaxExceededView,
    },
  ];
}
